
export default {
  data() {
    return {};
  },
  methods: {
    navigateToAddNewItemPage() {
      this.$router.push("/menu/new/item");
    },
    navigateToCreateComboPage() {
      this.$router.push("/menu/new/combo");
    },
    showAddonDialog() {
      this.$emit("show-addon-dialog");
    }
  }
};
